<template>
    <div no-body id="print">
        <b-row class="mx-2">
            <b-col>
                <card> 
                    <div slot="header">
                        <b-row >
                            <b-col cols="6">
                                <h1 class="mb-0">Net Worth Statement</h1>
                            </b-col>
                            <b-col cols="6" class="text-right">
                                <!-- <base-button type="primary" icon size="sm" @click.prevent="underDevelopment()">
                                    <span class="btn-inner--text">Send KYC To Customer</span>
                                </base-button> -->
                                <base-button type="primary" icon size="sm" v-b-toggle.collapse-4>
                                    <span class="btn-inner--icon"><i class="fas fa-caret-down"></i></span>
                                </base-button>
                            </b-col>
                        </b-row>
                    </div>
                    <!-- Card body -->
                    <b-collapse id=collapse-4 visible class="mx-6">
                        <div>
                            <h5 class="text-danger"> Note : <br>
                                <i>
                                    1. The blue color value indicated the value filled by customer.
                                </i>
                                <br>
                                <i>
                                    2. The gray color value indicated the value auto calculated by system.
                                </i>
                                <br>
                                <i>
                                    3. If the monthly column is being filled up, the annual value will be auto calculated; Vice versa.
                                </i>
                                <br>
                                <i>
                                    4. Advisory can only edit the column filled up by customer, if monthly column is filled up, advisory can only update the monthly column.
                                </i>
                                <br>
                                <i>
                                    5. For Assets, the customer answer will followed the same value as the advisory answer.
                                </i>
                            </h5>
                            <br>
                            <h2>{{cashIncomes[0].Cust_Info.Cust_Name}}</h2>
                            <table style="margin-bottom:20px">
                                <tr class="text-white">
                                    <th></th>
                                    <th style="width:10%">Customer Answer (RM)</th>
                                    <th style="width:10%">Advisory Answer (RM)</th>
                                </tr>
                                <!-- assets -->
                                <template>
                                    <tr v-if="loginUser.role_id == 1 || loginUser.role_id == 2">
                                        <td colspan="3"><b>Assets - from Advisor Manual Update</b></td>
                                    </tr>
                                    <tr v-else>
                                        <td colspan="3"><b>Assets</b></td>
                                    </tr>
                                    <template>
                                        <tr>
                                            <td colspan="3" class="pl-4"><b>Cash / Cash Equivalents</b>&nbsp;
                                                <base-button type="primary" icon size="sm" @click.prevent="addCustomerAssets('cash_equivalents')">
                                                    <span class="btn-inner--icon"><i class="fa fa-plus"></i></span>
                                                </base-button>
                                            </td>
                                        </tr>
                                        <tr v-for="(cash_equivalent, index) in assets[0].cash_equivalents" :key="cash_equivalent.customer_asset_id">
                                            <td><el-input type="text" min="0" size="small" id="admin-value" v-model="cash_equivalent.asset_title"/></td>
                                            <td class="text-gray">{{parseFloat(cash_equivalent.admin_value).toLocaleString(undefined, {minimumFractionDigits: 2})}}</td>
                                            <td>
                                                <el-input type="number" min="0" size="small" id="admin-value" v-model="cash_equivalent.admin_value">
                                                    <template #append>
                                                        <base-button type="primary" icon size="sm" @click.prevent="deleteCustomerAssets('cash_equivalents', index)">
                                                            <span class="fas fa-trash"></span>
                                                            <!-- <span class="btn-inner--text">Delete</span> -->
                                                        </base-button>
                                                    </template>
                                                </el-input>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="pl-4"><b>Total Cash / Cash Equivalents</b></td>
                                            <td><b>{{totalAssetAdminValue.cash_equivalents.toLocaleString(undefined, {minimumFractionDigits: 2})}}</b></td>
                                            <td><b>{{totalAssetAdminValue.cash_equivalents.toLocaleString(undefined, {minimumFractionDigits: 2})}}</b></td>
                                        </tr>
                                    </template>
                                    
                                    <template>
                                        <tr>
                                            <td colspan="3" class="pl-4"><b>Investment Assets</b>&nbsp;
                                                <base-button type="primary" icon size="sm" @click.prevent="addCustomerAssets('investment_assets')">
                                                    <span class="btn-inner--icon"><i class="fa fa-plus"></i></span>
                                                </base-button>
                                            </td>
                                        </tr>
                                        <tr v-for="(investment_asset, index) in assets[0].investment_assets" :key="investment_asset.customer_asset_id">
                                            <td><el-input type="text" min="0" size="small" id="admin-value" v-model="investment_asset.asset_title"/></td>
                                            <td class="text-gray">{{parseFloat(investment_asset.admin_value).toLocaleString(undefined, {minimumFractionDigits: 2})}}</td>
                                            <td>
                                                <el-input type="number" min="0" size="small" id="admin-value" v-model="investment_asset.admin_value">
                                                    <template #append>
                                                        <base-button type="primary" icon size="sm" @click.prevent="deleteCustomerAssets('investment_assets', index)">
                                                            <span class="fas fa-trash"></span>
                                                            <!-- <span class="btn-inner--text">Delete</span> -->
                                                        </base-button>
                                                    </template>
                                                </el-input>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="pl-4"><b>Total Investment Assets</b></td>
                                            <td><b>{{totalAssetAdminValue.investment_assets.toLocaleString(undefined, {minimumFractionDigits: 2})}}</b></td>
                                            <td><b>{{totalAssetAdminValue.investment_assets.toLocaleString(undefined, {minimumFractionDigits: 2})}}</b></td>
                                        </tr>
                                    </template>
                                    
                                    <template>
                                        <tr>
                                            <td colspan="3" class="pl-4"><b>Personal Use Assets</b>&nbsp;
                                                <base-button type="primary" icon size="sm" @click.prevent="addCustomerAssets('personal_assets')">
                                                    <span class="btn-inner--icon"><i class="fa fa-plus"></i></span>
                                                </base-button>
                                            </td>
                                        </tr>
                                        <tr v-for="(personal_asset, index) in assets[0].personal_assets" :key="personal_asset.customer_asset_id">
                                            <td><el-input type="text" min="0" size="small" id="admin-value" v-model="personal_asset.asset_title"/></td>
                                            <td class="text-gray">{{parseFloat(personal_asset.admin_value).toLocaleString(undefined, {minimumFractionDigits: 2})}}</td>
                                            <td>
                                                <el-input type="number" min="0" size="small" id="admin-value" v-model="personal_asset.admin_value">
                                                    <template #append>
                                                        <base-button type="primary" icon size="sm" @click.prevent="deleteCustomerAssets('personal_assets', index)">
                                                            <span class="fas fa-trash"></span>
                                                            <!-- <span class="btn-inner--text">Delete</span> -->
                                                        </base-button>
                                                    </template>
                                                </el-input>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="pl-4"><b>Total Personal Use Assets</b></td>
                                            <td><b>{{totalAssetAdminValue.personal_assets.toLocaleString(undefined, {minimumFractionDigits: 2})}}</b></td>
                                            <td><b>{{totalAssetAdminValue.personal_assets.toLocaleString(undefined, {minimumFractionDigits: 2})}}</b></td>
                                        </tr>
                                    </template>
                                    <tr>
                                        <td><b>Total Assets</b></td>
                                        <td><b>{{netWorthAdmin.asset.toLocaleString(undefined, {minimumFractionDigits: 2})}}</b></td>
                                        <td><b>{{netWorthAdmin.asset.toLocaleString(undefined, {minimumFractionDigits: 2})}}</b></td>
                                    </tr>
                                </template>
                                <tr>&nbsp;</tr>
                                <!-- liabilities -->
                                <template>
                                    <tr v-if="loginUser.role_id == 1 || loginUser.role_id == 2">
                                        <td colspan="3"><b>Liabilities - from IM2U</b></td>
                                    </tr>
                                    <tr v-else>
                                        <td colspan="3"><b>Liabilities</b></td>
                                    </tr>
                                    <tr>
                                        <td colspan="3" class="pl-4"><b>Current Liabilities</b></td>
                                    </tr>
                                    <template v-for="fixedExpense in fixedExpenses[0].im2u_liabilities">
                                        <tr :key="fixedExpense.loan_statue_name" v-if="fixedExpense.loan_statue != 'HSLNFNCE' && fixedExpense.loan_statue != 'PCPASCAR'">
                                            <td class="pl-5">{{fixedExpense.loan_statue_name}}</td>
                                            <td>{{fixedExpense.customer_curr_outstanding.toLocaleString(undefined, {minimumFractionDigits: 2})}}</td>
                                            <td>
                                                <el-input type="number" min="0" size="small" id="admin-value" v-model="fixedExpense.admin_curr_outstanding"></el-input>
                                            </td>
                                        </tr>
                                    </template>
                                    
                                    <tr>
                                        <td class="pl-4"><b>Total Current Liabilities</b> </td>
                                        <td><b>{{fixedExpenses[0].total_current_liability.toLocaleString(undefined, {minimumFractionDigits: 2})}}</b></td>
                                        <td><b>{{totalLiabilityAdminValue["current"].toLocaleString(undefined, {minimumFractionDigits: 2})}}</b></td>
                                    </tr>
                                    <tr>
                                        <td colspan="3" class="pl-4"><b>Long Term Liabilities</b></td>
                                    </tr>
                                    <template v-for="fixedExpense in fixedExpenses[0].im2u_liabilities" >
                                        <tr :key="fixedExpense.loan_statue_name" v-if="fixedExpense.loan_statue == 'HSLNFNCE' || fixedExpense.loan_statue == 'PCPASCAR'">
                                            <td class="pl-5">{{fixedExpense.loan_statue_name}}</td>
                                            <td>{{fixedExpense.customer_curr_outstanding.toLocaleString(undefined, {minimumFractionDigits: 2})}}</td>
                                            <td>
                                                <el-input type="number" min="0" size="small" id="admin-value" v-model="fixedExpense.admin_curr_outstanding"></el-input>
                                            </td>
                                        </tr>
                                    </template>
                                    <tr>
                                        <td class="pl-4"><b>Total Long Term Liabilities</b> </td>
                                        <td><b>{{fixedExpenses[0].total_long_term_liability.toLocaleString(undefined, {minimumFractionDigits: 2})}}</b></td>
                                        <td><b>{{totalLiabilityAdminValue["long_term"].toLocaleString(undefined, {minimumFractionDigits: 2})}}</b></td>
                                    </tr>
                                    <tr>
                                        <td><b>Total Liabilities</b> </td>
                                        <td><b>{{(fixedExpenses[0].total_current_liability+fixedExpenses[0].total_long_term_liability).toLocaleString(undefined, {minimumFractionDigits: 2})}}</b></td>
                                        <td><b>{{netWorthAdmin.liability.toLocaleString(undefined, {minimumFractionDigits: 2})}}</b></td>
                                    </tr>
                                </template>
                                <tr>&nbsp;</tr>
                                <tr>
                                    <td><b>Net Worth</b></td>
                                    <td><b>{{netWorthAdmin.total.customer_value.toLocaleString(undefined, {minimumFractionDigits: 2})}}</b></td>
                                    <td><b>{{netWorthAdmin.total.admin_value.toLocaleString(undefined, {minimumFractionDigits: 2})}}</b></td>
                                </tr>
                            </table> 
                        </div>
                        <el-table class="bank-eligibility table-responsive align-items-center table-flush"
                                    header-row-class-name="thead-light"
                                    :data="queriedData"
                                    @sort-change="sortChange"
                                    @selection-change="selectionChange"
                                    highlight-current-row
                                    @current-change="handleCurrentChange"
                                    row-key="id">
                            <el-table-column label="Name"
                                            min-width="80px"
                                            prop="Bank_Name"
                                            sortable>
                                <template v-slot="{row}">
                                <b>{{row.Bank_Name}}</b>
                                </template>
                            </el-table-column>

                            <el-table-column label="Credit Behaviour"
                                            min-width="130px"
                                            prop="Fintos_Score"
                                            sortable>
                                <template v-slot="{row}">
                                <b>{{row.Fintos_Score}}</b>
                                </template>
                            </el-table-column>

                            <el-table-column label="Estimated Best Rate (%)"
                                            min-width="150px"
                                            prop="Loan_Interest"
                                            sortable>
                                <template v-slot="{row}">
                                <b>{{parseFloat(row.Loan_Interest).toLocaleString(undefined, {minimumFractionDigits: 2})}}</b>
                                </template>
                            </el-table-column>

                            <el-table-column label="Eligibility Amount (RM)"
                                            min-width="150px"
                                            prop="Loan_Eligible"
                                            sortable>
                                <template v-slot="{row}">
                                    <b-col>
                                        <b-row>
                                            <b-img width="20px" fluid src="/img/bank_score_recommended_v2.png"></b-img>&nbsp;
                                            <b>{{parseFloat(row.Loan_Eligible).toLocaleString(undefined, {minimumFractionDigits: 2})}}</b>
                                        </b-row>
                                    </b-col>
                                </template>
                            </el-table-column>
                        </el-table>
                        <!-- <div>This Function / Module is currently Under Development, Please come back later.</div> -->
                    </b-collapse>
                </card>
            </b-col>
        </b-row>
    </div>
</template>
<script>
    import { Table, TableColumn, Select , Option } from 'element-ui'
    import axios from 'axios'
    import {apiGatewayDomain, getHeader} from '@/assets/js/config.js'
    import notifyFunctionMixin from '@/assets/js/notifyFunctionMixin.js'
    import clientPaginationMixin from '@/assets/js/clientPaginationMixin'
    import swal from 'sweetalert2';
    import 'sweetalert2/dist/sweetalert2.css';
    import cashIncomes from './cashincomes';
    import loanEligibilities from './loaneligibilities';
    import fixedExpensesData from './fixedexpenses';
    import customerAssets from './assets';
    import {getUserInfo} from '@/assets/js/config.js'

    export default {
        mixins: [notifyFunctionMixin, clientPaginationMixin],
        components: {
            [Select.name]: Select,
            [Option.name]: Option,
            [Table.name]: Table,
            [TableColumn.name]: TableColumn,
        },
        data() {
            return {
                loginUser : getUserInfo(),
                cashIncomes,
                loanEligibilities,
                fixedExpensesData,
                customerAssets,
                tableData: loanEligibilities[0].Bank_Info,
                selectedRows: [],
                selects:{
                    bank:[],
                },
                uniqueSubCategories: [],
                assetAdminValue: [],
                totalAssetAdminValue: {
                    cash_equivalents: 0,
                    investment_assets: 0,
                    personal_assets: 0,
                },
                netWorthAdmin: {
                    asset: 0,
                    liability: 0,
                    total: {
                        customer_value: 0,
                        admin_value: 0,
                    },
                },
                liabilityAdminValue: [],
                totalLiabilityAdminValue: {
                    current: 0,
                    long_term: 0,
                },
                isSelected: false,
            };
        },
        created() {
            // this.initialAsset();
            // below code needed to run the computed and watch on created
            this.customerAssets = {...customerAssets};    
            this.fixedExpensesData = {...fixedExpensesData};   
        },
        computed:{
            assets() {
                const {customerAssets} = this
                return customerAssets
            },
            fixedExpenses() {
                const {fixedExpensesData} = this
                return fixedExpensesData
            }
            
        },
        watch: {
            assets: {
                handler: function(val) {
                    let totalAssetAdminValue = {
                        cash_equivalents: 0,
                        investment_assets: 0,
                        personal_assets: 0,
                    };
                   
                    // cash equivalents
                    val[0].cash_equivalents.filter(function(data, idx) {
                        totalAssetAdminValue.cash_equivalents += parseFloat(data.admin_value);
                    });

                    // investment assets
                    val[0].investment_assets.filter(function(data, idx) {
                        totalAssetAdminValue.investment_assets += parseFloat(data.admin_value);
                    });

                    // personal use assets
                    val[0].personal_assets.filter(function(data, idx) {
                        totalAssetAdminValue.personal_assets += parseFloat(data.admin_value);
                    });

                    this.totalAssetAdminValue = totalAssetAdminValue;
                    
                    this.getNetWorth();
                },
                deep: true,
            },
            fixedExpenses: {
                handler: function(val) {
                    let liabilityAdminValue = this.liabilityAdminValue
                    let totalLiabilityAdminValue = this.totalLiabilityAdminValue;
                    val[0].im2u_liabilities.filter( function( data, idx ) {
                        if(data.loan_statue == "HSLNFNCE" || data.loan_statue == "PCPASCAR") 
                        {
                            liabilityAdminValue['long_term'] = {
                                ...liabilityAdminValue['long_term'],
                                [data.im2u_liability_id]: parseFloat(data.admin_curr_outstanding)
                            };
                            totalLiabilityAdminValue['long_term'] = 0;
                        }
                        else
                        {
                            liabilityAdminValue['current'] = {
                                ...liabilityAdminValue['current'],
                                [data.im2u_liability_id]: parseFloat(data.admin_curr_outstanding)
                            };
                            totalLiabilityAdminValue['current'] = 0;
                        }
                    });
                    Object.keys(liabilityAdminValue).forEach((key) => {
                        Object.values(liabilityAdminValue[key]).forEach((data) => {
                            if(isNaN(data))
                            {
                                data = 0;
                            }
                            totalLiabilityAdminValue[key] += data;
                        });                    
                    });     

                    this.getNetWorth();
                },
                deep: true,
            },
        },
        methods: {
            selectionChange(selectedRows) {
                this.selectedRows = selectedRows
            },
            handleCurrentChange(selectedRow){
                this.$notify({
                    message: '<b>' + selectedRow.Bank_Name + ' is selected as the recommended bank for this customer.</b>',
                    timeout: 1500,
                    icon: 'ni ni-bulb-61',
                    type: 'success',
                });
                this.selects.bank = selectedRow;
                this.getNetWorth();
            },
            close() {
                this.$router.back();
            },
            addCustomerAssets(asset_type_name) {
                this.customerAssets[0][asset_type_name].push({admin_value: 0});
            },
            deleteCustomerAssets(asset_type_name, index) {
                this.customerAssets[0][asset_type_name].splice(index, 1);
            },
            initialAsset() {
                let uniqueCategory= [];
                let uniqueSubCategory= [];
                let totalAssetAdminValue = [];
                Object.values(customerAssets[0].customer_assets).forEach((data) => {
                    
                    // set category
                    if(uniqueCategory.indexOf(data.customer_template_category.customer_category_name) < 0)
                    {
                        uniqueCategory[data.customer_template_category.customer_category_sort] = data.customer_template_category.customer_category_name;
                    }
                    if(uniqueSubCategory.indexOf(data.customer_template_category.customer_sub_category_name) < 0)
                    {
                        uniqueSubCategory[data.customer_template_category.customer_sub_category_sort] = data.customer_template_category.customer_sub_category_name;
                        totalAssetAdminValue[data.customer_template_category.customer_sub_category_name] = 0;
                    }
                });
                this.uniqueSubCategories = uniqueSubCategory;
                this.totalAssetAdminValue = totalAssetAdminValue;  
 
            },
            getTotalAsset() {
                this.netWorthAdmin.asset = 0;
                Object.values(this.totalAssetAdminValue).forEach((data) => {
                    this.netWorthAdmin.asset += data;
                });
            },
            getTotalLiability() {
                this.netWorthAdmin.liability = 0;
                Object.values(this.totalLiabilityAdminValue).forEach((data) => {
                    this.netWorthAdmin.liability += data;
                });
            },
            getNetWorth() {
                this.getTotalAsset();
                this.getTotalLiability();
                let netWorth = {
                    customer_value: this.netWorthAdmin.asset - (this.fixedExpenses[0].total_current_liability+this.fixedExpenses[0].total_long_term_liability),
                    admin_value: this.netWorthAdmin.asset - this.netWorthAdmin.liability,
                };
                this.netWorthAdmin = {...this.netWorthAdmin, total: netWorth}

                const netWorthStatementData = {
                    assets: this.netWorthAdmin.asset,
                    liabilities: {
                        ...this.totalLiabilityAdminValue,
                        total: this.netWorthAdmin.liability,
                    },
                    net_worth: this.netWorthAdmin.total,
                    loan_eligible: this.selects.bank,
                }
                this.$emit('net-worth-statement-data', netWorthStatementData);
            },
        }
    };
</script>
<style scoped>
table {
    font-family: arial, sans-serif;
    border-collapse: collapse;
    width: 100%;
}

td , th {
    border: 1px solid #dddddd;
    text-align: center;
    /* height: 10px; */
    /* width: 20%; */
}

td:first-child {
    text-align: left;
    padding-left: 8px;
}

th {
    background-color: #525f7f;
    font-size: large;
    width: 20%;
}

.button-right {
    padding-right: 0;
}
</style>
<style>
#admin-value {
    text-align:center;
    font-size:medium;
}
.el-table__body tr.current-row>td.el-table__cell {
    background-color: #87f6a4;
}
.el-table__row:hover
{
    background-color: #eaecef !important;
}
.bank-eligibility thead th {
    font-size: .845rem !important;
}
.bank-eligibility td {
    font-size: 1rem !important;
}
</style>